import { Button, Paper, Stack, TextField, Typography, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuthContext } from 'src/auth/useAuthContext';
import CustomInput from 'src/components/customerinput/CustomerInput';
import CustomModal from 'src/components/customerinput/CustomModal';
import { notify } from 'src/components/notify';
import updateEventStatus from 'src/services/events/updateEventStatus';

export default function ActionModel({ open, close, type, eventData }) {
    const navigate = useNavigate()
    const { user, logout } = useAuthContext();
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        setError('');
        if ((type === 'rejected' || type === 'needs_improvement') && !reason.trim()) {
            setError('Reason is required.');
            return;
        }

        try {
            setLoading(true);

            const payload = {
                reason: type === 'approved' ? 'Event Approved Successfully' : reason,
                status: type,
            };

            const response = await updateEventStatus(user, eventData?._id, logout, payload);

            if (response) {
                notify(
                    type === 'approved'
                        ? 'Event approved successfully!'
                        : type === 'rejected'
                            ? 'Event rejected successfully!'
                            : 'Improvement note submitted successfully!', "success"
                );
                navigate(-1)
                close();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustomModal
            open={open}
            close={close}
            heading={
                type === 'rejected'
                    ? 'Reject Event Listing'
                    : type === 'needs_improvement'
                        ? 'Needs Improvement'
                        : 'Approve Event Listing'
            }
            action={
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading}
                    sx={{ minWidth: 120 }}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Confirm'}
                </Button>
            }
        >
            <Paper sx={{ padding: 2, border: 1, borderColor: 'divider', mb: 2 }}>
                <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
                    <Typography>Vendor Name</Typography>
                    <Typography>{eventData?.user_info?.name}</Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                    <Typography>Event Name</Typography>
                    <Typography>{eventData?.name}</Typography>
                </Stack>
            </Paper>

            {(type === 'rejected' || type === 'needs_improvement') && (
                <>
                    <CustomInput
                        label="Reason / Note"
                        input={
                            <TextField
                                fullWidth
                                multiline
                                minRows={6}
                                maxRows={18}
                                placeholder="Add details about reason"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                error={!!error}
                                helperText={error}
                            />
                        }
                    />
                </>
            )}

            {type === 'approved' && (
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1, fontSize: "16px" }}>
                    Are you sure you want to approve this event? Once approved, it will be visible to users.
                </Typography>
            )}
        </CustomModal>
    );
}
